import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { API_REQUEST_URL } from '../../../common/apiConfig';
import {
  MANAGE_SUBS_REMOVE_CUSTOMER_BEGIN,
  MANAGE_SUBS_REMOVE_CUSTOMER_SUCCESS,
  MANAGE_SUBS_REMOVE_CUSTOMER_FAILURE,
  MANAGE_SUBS_REMOVE_CUSTOMER_DISMISS_ERROR,
  MANAGE_SUBS_UPDATE_CUSTOMER_LIST,
} from './constants';

export function removeCustomer(args = {}) {
  return (dispatch, getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_REMOVE_CUSTOMER_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const cognitoIdToken = getState().home.auth.cognitoIdToken;
      const token = `Bearer ${cognitoIdToken}`;
      const doRequest = axios.delete(`${API_REQUEST_URL}/removeCustomer`, {
        headers: {
          'Authorization': token,
        },
        data: args,
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_REMOVE_CUSTOMER_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_REMOVE_CUSTOMER_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}
export function updateCustomerList(record) {
  return (dispatch, getState) => { 
    const customerData = getState().manageSubs.customerData;
    dispatch({
      type: MANAGE_SUBS_UPDATE_CUSTOMER_LIST,
      data: customerData.filter(item=>item.customerId !== record.customerId),
    });
  }
}
export function dismissRemoveCustomerError() {
  return {
    type: MANAGE_SUBS_REMOVE_CUSTOMER_DISMISS_ERROR,
  };
}

export function useRemoveCustomer() {
  const dispatch = useDispatch();

  const { removeCustomerPending, removeCustomerError } = useSelector(
    state => ({
      removeCustomerPending: state.manageSubs.removeCustomerPending,
      removeCustomerError: state.manageSubs.removeCustomerError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(removeCustomer(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissRemoveCustomerError());
  }, [dispatch]);
  const boundUpdateCustomerList = useCallback((...args) => {
    return dispatch(updateCustomerList(...args));
  }, [dispatch]);
  return {
    removeCustomer: boundAction,
    removeCustomerPending,
    removeCustomerError,
    dismissRemoveCustomerError: boundDismissError,
    updateCustomerList: boundUpdateCustomerList,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_REMOVE_CUSTOMER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        removeCustomerPending: true,
        removeCustomerError: null,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMER_SUCCESS:
      // The request is success
      return {
        ...state,
        removeCustomerPending: false,
        removeCustomerError: null,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMER_FAILURE:
      // The request is failed
      return {
        ...state,
        removeCustomerPending: false,
        removeCustomerError: action.data.error,
      };

    case MANAGE_SUBS_REMOVE_CUSTOMER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        removeCustomerError: null,
      };

      case MANAGE_SUBS_UPDATE_CUSTOMER_LIST:
        // The request is success
        return {
          ...state,
          customerData: action.data,
        };
    default:
      return state;
  }
}
